import React from 'react';

import { ReactComponent as NotFound } from '../../../assets/logos/not_found.svg';
import { Button, Layout } from '../../../components';
import { useAuth } from '../../../hooks/useAuth';
import useRedirect from '../../../hooks/useRedirect';
import { RoutesPaths } from '../../../routes';
import api from '../../../services/api';
import { GridContainer, Grid, RightGrid } from './styles';

export const SessionUnauthorized: React.FC = () => {
  const redirect = useRedirect();
  const { user } = useAuth();

  const storage = localStorage.getItem('@PortalUnicred/expire');

  const handleClick = () => {
    if (storage) {
      window.location.href = `${localStorage.getItem('@PortalUnicred/expire')}`;

      localStorage.removeItem('@PortalUnicred/user');
      localStorage.removeItem('@PortalUnicred/sessionToken');
      localStorage.removeItem('@PortalUnicred/expire');
      api.defaults.headers.authorization = '';
    } else if (user) {
      redirect(RoutesPaths.home);
    } else {
      redirect(RoutesPaths.login);
    }
  };

  return (
    <>
      <Layout
        headerProtect
        hideFloatingButton
        hideFooter
        hideBackbar
        hideInstructionModal
        titlePage={'Acesso Negado'}
      >
        <GridContainer>
          <Grid>
            <NotFound />
          </Grid>
          <Grid>
            <RightGrid>
              <h1>403</h1>
              <h2>Lamentamos! Acesso negado :(</h2>

              <p>Clique no botão abaixo para ser redirecionado para página.</p>
              <div>
                <Button variant="solid" onClick={handleClick}>
                  {user && !storage ? 'Ir para a home' : 'Login'}
                </Button>
              </div>
            </RightGrid>
          </Grid>
        </GridContainer>
      </Layout>
    </>
  );
};
